export const productsHero = {
  eyebrow: 'Our Products',
  description:
    'We provide a wide range of high-quality metals sourced from trusted global suppliers and delivered with reliability and consistency.',
  image: '/assets/products-hero-metals.png',
  imageAlt: 'Premium metal bars, copper pipes and brass tubes',
  primaryCta: { label: 'Request Quote', to: '/contact#quote-form' },
  secondaryCta: { label: 'Send Inquiry', to: '/contact#inquiry-form' },
}
